import React from 'react';
import classnames from 'classnames';
import s from './EmptyBackground.scss';
export const EmptyBackground = ({ className })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], className)
    });
};
EmptyBackground.displayName = 'EmptyBackground';
export default EmptyBackground;

//# sourceMappingURL=EmptyBackground.js.map